import type { ReactNode } from 'react';
import { Link, useLocation } from 'react-router';
import { useAuth } from '@/features/auth/authContext';
import { DensePagePanel, DensePageShell } from '@/components/layout/DensePageShell';
import { findDestinationById, userCanAccessDestination } from '@/navigation/registry';
import { ESTIMATING_AREAS, estimatingAreaForPath } from './hub/estimatingHub';
import './estimating-workspace.css';

/**
 * Chrome for every Estimations & Bids route, new or legacy: the six primary
 * areas, then the page. Project tabs are rendered by ProjectWorkspacePage so
 * that legacy deep tools (takeoff, comping, ...) keep their own page header.
 */
export function EstimatingWorkspaceShell({ children }: { children: ReactNode }) {
  const { permissions } = useAuth();
  const location = useLocation();
  const area = estimatingAreaForPath(location.pathname);
  const areas = ESTIMATING_AREAS.filter((item) => {
    const destination = findDestinationById(item.destinationId);
    return destination ? userCanAccessDestination(destination, permissions) : false;
  });
  return (
    <DensePageShell className="estimating-workspace">
      <nav className="ew-nav" aria-label="Estimations and bids areas">
        {areas.map((item) => (
          <Link key={item.id} to={item.to} aria-current={area === item.id ? 'page' : undefined}>
            {item.label}
          </Link>
        ))}
      </nav>
      <DensePagePanel className="ew-content">{children}</DensePagePanel>
    </DensePageShell>
  );
}
